import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({
  themeMode: 'dark',
  isDark: true,
  toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('verveai_theme_mode');
      if (stored === 'light' || stored === 'dark') return stored;
    }
    return 'dark';
  });

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', themeMode);
      document.documentElement.classList.toggle('light', themeMode === 'light');
      document.documentElement.classList.toggle('dark', themeMode === 'dark');
      if (document.body) {
        document.body.classList.toggle('light-theme', themeMode === 'light');
        document.body.classList.toggle('dark-theme', themeMode === 'dark');
      }
      localStorage.setItem('verveai_theme_mode', themeMode);
    }
  }, [themeMode]);

  const toggleTheme = () => {
    setThemeMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <ThemeContext.Provider value={{ themeMode, isDark: themeMode === 'dark', toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
